import React from "react";
import RFamily from "../../PicesForPages/FHAVAStreamline.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function FhaVaStreamline() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent FhaVaStreamlinePageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={RFamily}
          alt="RFamilyImage"
          className="background-video FHAVAStreamlineImage"
        />
        <div className="purchasetopBox FhaVaStreamlinePageTopBox">
          {/* The existing Purchase span */}
          <span>FHA VA Streamline Refinance</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">
              Are you currently holding an FHA or VA loan?
            </span>
            <span className="purchaseBottomLeftContent">
              We have the perfect solution for you – the Streamline Program! You
              may be able to skip a monthly mortgage payment and even receive
              cash back after closing, putting extra money right into your
              pocket.
            </span>

            <span className="purchaseBottomLeftHeader">
              Explore the benefits!
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Lower monthly mortgage payments</li>
              <li>Reduced interest rate</li>
              <li>No out-of-pocket costs</li>
              <li>No credit score requirements</li>
              <li>Flexible terms of 15, 20, or 30 years </li>
            </ul>

            <span className="purchaseBottomLeftHeader">
              Streamline Refinance
            </span>
            <span className="purchaseBottomLeftContent">
              This refinance option is designed similar to the FHA Streamline
              Program, requiring minimal documentation, and we also provide
              exclusive purchase programs tailored specifically for Veterans!
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default FhaVaStreamline;
